import { render, staticRenderFns } from "./examination_room_list.vue?vue&type=template&id=0c2703d8&scoped=true&"
import script from "./examination_room_list.vue?vue&type=script&lang=js&"
export * from "./examination_room_list.vue?vue&type=script&lang=js&"
import style0 from "./examination_room_list.vue?vue&type=style&index=0&id=0c2703d8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c2703d8",
  null
  
)

export default component.exports